import { render, staticRenderFns } from "./SingProduct.vue?vue&type=template&id=652ed646&scoped=true"
import script from "./SingProduct.vue?vue&type=script&lang=js"
export * from "./SingProduct.vue?vue&type=script&lang=js"
import style0 from "./SingProduct.vue?vue&type=style&index=0&id=652ed646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652ed646",
  null
  
)

export default component.exports